export const useStoreApp = defineStore('app', () => {
  const isModalFullPage = ref(false)
  const modalsOpenedCount = ref(0)
  const appWidth = ref(0)
  const customerId = ref('')

  const domModalsCount = ref(0)

  const isMobile = computed(() => appWidth.value < 768)

  const companyId = ref(0)

  const isAccountContext = ref(false)

  return {
    companyId,
    isModalFullPage,
    modalsOpenedCount,
    isMobile,
    appWidth,
    domModalsCount,
    customerId,
    isAccountContext
  }
})
